module.exports = __webpack_public_path__ + "static/img/co_cde__dept_rgb_v.27a68b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/co_cde__dept_rgb_v.png
// module id = +IMo
// module chunks = 3